import { render, staticRenderFns } from "./user-selector-in-dialog.vue?vue&type=template&id=15c235a4&scoped=true"
import script from "./user-selector-in-dialog.vue?vue&type=script&lang=js"
export * from "./user-selector-in-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-selector-in-dialog.vue?vue&type=style&index=0&id=15c235a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c235a4",
  null
  
)

export default component.exports